import React, { useState, ReactElement } from "react";
import styles from "../../styles/admanager/UserEarningsReport.module.scss";
import GenericTable from "../../containers/helpers/genericTable";
import GenericInput from "../../containers/helpers/genericInput";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons/faFilter";
// import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import {
  ItemProps,
  MultiSelectDropdown,
} from "../../containers/helpers/MultiSelectDropdown";
import { WorkState } from "../../reducers/models";
import {
  nonAggregatable,
  reportColumnMetaData,
  ReportColumns,
  ReportHeader,
  HeaderProps,
  IAdboxReport,
} from "../../constants/earningsReport";
import Spinner from "../Spinner";
import { useDispatch } from "react-redux";
import {
  setbundleFilterWord,
  setPlatformOSFilter,
  setNetworkFilter,
} from "../../actions/monetization";
import { useSelector } from "react-redux";
import { getFilteredReport } from "../../selectors/monetizationSelector";

function Header({
  title,
  children = [],
  expandIcon,
  expandHover,
  setExpand,
  expanded,
  hoverText,
}: HeaderProps): ReactElement {
  function toggleExpanded() {
    if (setExpand !== undefined) setExpand(!expanded);
  }

  let expandButton: ReactElement | undefined;
  if (expandIcon !== undefined) {
    expandButton = (
      <FontAwesomeIcon
        onClick={toggleExpanded}
        title={expandHover}
        icon={expandIcon as any}
      />
    );
  }
  return (
    <div
      className={classnames(styles.tableHeader, {
        [styles.expanded]: expanded,
      })}
    >
      <abbr className={styles.abbr} title={hoverText}>
        <h3>
          {title} <span>{expandButton}</span>
        </h3>
      </abbr>
      {
        // if expanded, render the children, otherwise don't
        expanded ? (
          <div className={styles.filterOptions}>{children}</div>
        ) : undefined
      }
    </div>
  );
}

// todo:
// export function RenderAdReportTable({workState, appLovin:report}:IAdboxReport, columnInfo:ItemProps[], chandleChecked:(id:string, checked:boolean)=>void):ReactElement {
type osPlateformFilter = bb.model.monetization.osPlatformFilter;
type INetworkFilter = bb.model.monetization.INetworkFilter;
type IAdBoxNetworkReportItem = bb.model.monetization.IAdBoxNetworkReportItem;
// type IAppLovinReportItem = bb.model.monetization.IAdBoxNetworkReportItem;

export function RenderAdReportTable({
  workState,
  networkReports,
}: IAdboxReport): ReactElement {
  const dispatch = useDispatch();
  //TODO: may break filter, double check the content Android to Andriod
  const initialPlatform = [
    { id: "ios", content: "iOS", checked: true },
    { id: "andriod", content: "Android", checked: true },
  ];
  const initialNetworksFilter = [
    { id: "applovin", content: "AppLovin", checked: true },
    { id: "vungle", content: "vungle", checked: true },
  ];
  const [osPlatform, setOSPlatform] = useState<ItemProps[]>(initialPlatform);
  const [networksFilter, setNetowkrsFilter] = useState<ItemProps[]>(
    initialNetworksFilter
  );
  const filteredReport = useSelector(getFilteredReport);
  const [buindleExpanded, setBundleExpanded] = useState<boolean>(false);
  const [platFormOptionsExpanded, setPlatFormOptionsExpanded] = useState<
    boolean
  >(false);
  const [networkFormOptionsExpanded, setNetworkFormOptionsExpanded] = useState<
    boolean
  >(false);

  const headers: ReportHeader[] = [
    {
      title: "Bundle Id",
      Header: (
        <Header
          title={"Bundle ID"}
          expandHover={"Filter rows by bundle ID"}
          expandIcon={faFilter}
          expanded={buindleExpanded}
          setExpand={setBundleExpanded}
          hoverText={reportColumnMetaData.package_name.hoverText}
        >
          <div>
            <GenericInput
              type={"text"}
              placeholder={"filter by bundle id"}
              inputName={"bundleId"}
              inputValue={filteredReport.word}
              changeCallback={(name, value) =>
                dispatch(setbundleFilterWord(value))
              }
              // keyDown={(name,value) => dispatch(setFilteredTable())}
              // errorMessage={errorText.navaluee}
              // styles={inputStyles}
              // icon={faUser}
              autoFocus={true}
            />
          </div>
        </Header>
      ),
      accessor: ReportColumns.package_name,
    },
    {
      title: "Country",
      Header: (
        <Header
          title={"Country"}
          hoverText={reportColumnMetaData.country.hoverText}
        />
      ),
      accessor: ReportColumns.country,
    },
    
    {
      title: "Ad Type",
      Header: (
        <Header
        title={"Ad Type"}
        hoverText={reportColumnMetaData.ad_type.hoverText}
        />
        ),
        accessor: ReportColumns.ad_type,
      },
      {
        title: "Device Type",
        Header: (
          <Header
          title="Device Type"
          hoverText={reportColumnMetaData.device_type.hoverText}
          />
          ),
          accessor: ReportColumns.device_type,
        },
        
        {
          title: "Ad Network",
          Header: (
            <Header
              title={"Ad Network"}
              hoverText={reportColumnMetaData.networkName.hoverText}
              expandIcon={faFilter}
              expanded={networkFormOptionsExpanded}
              setExpand={setNetworkFormOptionsExpanded}
            >
              <MultiSelectDropdown
                items={networksFilter}
                buttonContent={"Choose Network"}
                onChecked={handleNetworkChecked}
                className={styles.showHideButton}
              />
            </Header>
          ),
          accessor: ReportColumns.networkName,
        },
    {
      title: "Platform (OS)",
      Header: (
        <Header
          title={"Platform (OS)"}
          expandIcon={faFilter}
          expanded={platFormOptionsExpanded}
          setExpand={setPlatFormOptionsExpanded}
          hoverText={reportColumnMetaData.platform.hoverText}
        >
          <MultiSelectDropdown
            items={osPlatform}
            buttonContent={"Choose platForm"}
            onChecked={handlePlatformChecked}
            className={styles.showHideButton}
          />
        </Header>
      ),
      accessor: ReportColumns.platform,
    },
    {
      title: "Impressions",
      Header: (
        <Header
          title={"Impressions"}
          hoverText={reportColumnMetaData.impressions.hoverText}
        />
      ),
      accessor: ReportColumns.impressions,
    },
    {
      title: "Revenue",
      Header: (
        <Header
          title={"Revenue"}
          hoverText={reportColumnMetaData.revenue.hoverText}
        />
      ),
      accessor: ReportColumns.revenue,
    },
    {
      title: "eCPM",
      Header: (
        <Header
          title={"eCPM"}
          hoverText={reportColumnMetaData.ecpm.hoverText}
        />
      ),
      accessor: ReportColumns.ecpm,
    },
    {
      title: "Clicks",
      Header: (
        <Header
          title={"Clicks"}
          hoverText={reportColumnMetaData.clicks.hoverText}
        />
      ),
      accessor: ReportColumns.clicks,
    },
    {
      title: "CTR",
      Header: (
        <Header title={"CTR"} hoverText={reportColumnMetaData.ctr.hoverText} />
      ),
      accessor: ReportColumns.ctr,
    },
  ];

  const initialColumnInfo = headers
    .filter((header) => reportColumnMetaData[header.accessor].aggregatable)
    .map<ItemProps>((header) => {
      return {
        id: header.accessor,
        content: header.title,
        checked: true,
      };
    });

  const [columnInfo, setColumnInfo] = useState<ItemProps[]>(initialColumnInfo);

  function handlePlatformChecked(id: string, checked: boolean): void {
    const itemIndex = osPlatform.findIndex((val) => val.id === id);
    if (itemIndex > -1) {
      const newPlatInfo = [...osPlatform];
      newPlatInfo[itemIndex].checked = checked;
      setOSPlatform(newPlatInfo);

      const osFilter: osPlateformFilter = {
        ios: newPlatInfo[0].checked,
        android: newPlatInfo[1].checked,
      };
      dispatch(setPlatformOSFilter(osFilter));
    }
  }

  function handleNetworkChecked(id: string, checked: boolean): void {
    console.log(id, checked)
    const itemIndex = networksFilter.findIndex((val) => val.id === id);
    console.log(itemIndex)
    if (itemIndex > -1) {
      const newNetWorkFilter = [...networksFilter];
      newNetWorkFilter[itemIndex].checked = checked;
      setNetowkrsFilter(newNetWorkFilter);

      const NetworkFilter: INetworkFilter = {
        appLovin: newNetWorkFilter[0].checked,
        vungle: newNetWorkFilter[1].checked
      };
      dispatch(setNetworkFilter(NetworkFilter));
    }
  }

  function handleChecked(id: string, checked: boolean) {
    const itemIndex = columnInfo.findIndex((val) => val.id === id);
    if (itemIndex > -1) {
      const newColumnInfo = [...columnInfo];
      newColumnInfo[itemIndex].checked = checked;
      setColumnInfo(newColumnInfo);
    }
  }

  const headerMap = headers.reduce<Record<ReportColumns, number>>(
    (map, header, i) => {
      map[header.accessor] = i;
      return map;
    },
    {} as Record<ReportColumns, number>
  );

  /**
   * return an array of required and selected headers
   * retaining their relative order in the headers array
   * @param columnInfo
   * @returns
   */
  function getSelectedHeaders(
    columnInfo: ItemProps[],
    reportRows: IAdBoxNetworkReportItem[]
  ): ReportHeader[] {
    // const headerCopy = {...headerMap}
    // filter out columns not found in the report

    if (reportRows.length > 0) {
      const exampleRow = reportRows[0];
      columnInfo = columnInfo.filter((column) => column.id in exampleRow);
    }

    let result = [headers[headerMap[ReportColumns.package_name]]];
    result = result.concat(
      nonAggregatable.map((col) => headers[headerMap[col]])
    );

    for (let column of columnInfo) {
      // only the checked columns
      if (column.checked) {
        const index = headerMap[column.id as ReportColumns];
        result[index] = headers[index];
      }
    }

    // remove any undefined's (AKA unselected columns)
    result = result.reduce<ReportHeader[]>((arr, header) => {
      const exampleRow: any = reportRows[0];
      if (header !== undefined && exampleRow[header.accessor]) {
        arr.push(header);
      }
      return arr;
    }, []);

    return result;
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: "currency",
    //TODO: can change region (modular)
    currency: "USD",
  })

  const convertRows = (reportItems: IAdBoxNetworkReportItem[]): IAdBoxNetworkReportItem[] => {
    const updateAdBoxRows: IAdBoxNetworkReportItem[] = (reportItems as any[]).map(
      (reportItem: any) => (
        {
          ...reportItem,
          ECPM: formatter.format(reportItem.ecpm),
          CTR: `${reportItem.ctr} %`,
          Revenue: reportItem.revenue ? formatter.format(parseFloat(reportItem.revenue)) : formatter.format(reportItem.revenue),
          DeviceType: reportItem.device_type || 'N/A'
        } as any
      )
    );
    

    return updateAdBoxRows;
  };
  switch (workState) {
    case WorkState.None:
      return <></>;
    case WorkState.Error:
      return <h3 className={styles.errorText}>ERROR!</h3>;
    case WorkState.Loading:
      return <Spinner isLoading={true} spinnerStyle={{}} />;
    case WorkState.Success:
      if (networkReports === undefined || networkReports.length === 0) {
        return (
          <h3 className={styles.emptyReportText}>
            No earnings reported between the Months selected
          </h3>
        );
      }
      const selectedHeaders = getSelectedHeaders(columnInfo, networkReports);
      return (
        <div className={styles.reportContainer}>
          <div className={styles.reportTitle}>
            <h4>Report Result:</h4>
            <MultiSelectDropdown
              items={columnInfo}
              buttonContent={"Show / Hide Columns"}
              onChecked={handleChecked}
              className={styles.showHideButton}
            />
          </div>
          <GenericTable
            data={convertRows(filteredReport.networkReports)}
            columns={selectedHeaders}
            containerClassname={styles.reportTable}
            tablePaginationProps={{ pageItem: 10 }}
            scrollToOption={false}
          />
        </div>
      );
    default:
      return (
        <div>
          <h1>Not working</h1>
        </div>
      );
  }
}
